import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Option from '../Option';
import { SelectContainer, OptionContainer } from './Select.styles';
/**
 * Renders a custom `select` element.
 *
 * @public
 * @author Connor Taylor
 */

var Select =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Select, _Component);

  function Select() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (e) {
      return _this.props.onChange(e.target.value);
    });

    return _this;
  }

  var _proto = Select.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        items = _this$props.items,
        className = _this$props.className,
        rest = _objectWithoutPropertiesLoose(_this$props, ["items", "className"]);

    var optionElems = items.map(function (o) {
      return React.createElement(Option, {
        value: o.value,
        key: o.label
      }, o.label);
    });
    return React.createElement(SelectContainer, {
      className: className
    }, React.createElement(OptionContainer, _extends({
      onChange: this.onChange
    }, rest), optionElems));
  };

  return Select;
}(Component);

Select.defaultProps = {
  items: []
};
export default Select;